import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { ClubInfo, ClubList, createClubList } from 'src/data/club-course';
import { getDistanceInKM } from 'src/globals';
import { ClubService } from 'src/providers/club-service/club-service';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';

@Component({
  selector: 'app-add-state-list',
  templateUrl: './add-state-list.page.html',
  styleUrls: ['./add-state-list.page.scss'],
})
export class AddStateListPage implements OnInit {
  clubList: ClubList;
  openedModal: boolean     = false;
  searchQuery: string;
  stateList: Array<string> = ['Kuala Lumpur', 'Labuan', 'Purajaya'];
  navigationExtras :NavigationExtras={};  
  dataExtras:any;
  constructor(
    private navParams: NavParams,
    private geo: GeolocationService,
    private clubService: ClubService,
    private modalCtl: ModalController,
    private router: Router,
  ) {
    this.clubList    = createClubList();
    this.dataExtras = this.router.getCurrentNavigation().extras.state;
 
    this.openedModal=this.dataExtras.fromBookNow;
   }

  ngOnInit() {
    this.refreshClubs(null, null);
  }
  onSearchInput(event) {
    this._clearItems();
    this.refreshClubs(null, null);
}

/**
 * Gets the distance between a current location and club in KMs
 * @param club The club information
 * @returns {number} Returns the distance in KM if GPS locations of current and club are available
 * else returns 0;
 */
clubDistance(club: ClubInfo): string {
    let lat1 = this.geo.getLatitude();
    let lon1 = this.geo.getLongitude();
    if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
        return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + " KM";
    return "";
}

/**
 * Executed when refresh button on toolbar is clicked
 */
onRefreshClick(refresher) {
    this._clearItems();
    this.refreshClubs(refresher, null);
}

doInfinite(infinite) {
 
    if (this.isMore()) {
        this.refreshClubs(null, infinite);
    }
    // else {
    //     infinite.complete();
    //     infinite.enable(false);
    // }

}

clubSelected(event, item: ClubInfo) {

    if (this.openedModal) {
        this.modalCtl.dismiss(item);
    }
}

close() {
    this.modalCtl.dismiss();
}

private _clearItems() {
    this.clubList = createClubList();
}

refreshClubs(refresher, infinite) {
    this.clubService.searchClubs(this.searchQuery, true, this.clubList.currentPage + 1)
        .subscribe((clubList: ClubList) => {
            // if (clubList.totalPages > 0)
            //     clubList.currentPage++;
            this.clubList.currentPage = clubList.currentPage;
            this.clubList.totalPages  = clubList.totalInPage;
            this.clubList.totalItems  = clubList.totalItems;
            this.clubList.clubs.push(...clubList.clubs);
         
        }, (error) => {

        }, () => {
            //Handle the refresher or infinite
            if (refresher && refresher.complete) refresher.complete();
            if (infinite) {
                if (infinite.complete) infinite.target.complete();
                if (this.isMore()) {
                    infinite.target.enable(true);
                }
                else infinite.target.enable(false);
            }
        });
}

    isMore(): boolean {
    return this.clubList.totalPages > 0
        && this.clubList.currentPage < this.clubList.totalPages;
}

}
